import { StyleSheet } from 'react-native';

enum COLORS {
  errorColor = '#e64545',
  lighterGray = '#BAC0CA',
  white = '#ffffff',
  secondaryText = '#CDD1D9',
  dimViolet = '#B8ABBA',
}

const textStyles = StyleSheet.create({
  normalText: {
    fontSize: 16,
    fontWeight: '500',
    color: COLORS.white,
    textAlign: 'center',
  },
  smallText: {
    fontSize: 14,
    fontWeight: '500',
    color: COLORS.white,
    textAlign: 'center',
  },
});

export { COLORS, textStyles };
